module.exports = __webpack_public_path__ + "static/media/imgAbout.f8e97c28.jpg";